<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <div style="margin-bottom: 20px;"></div>
    <el-row >
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top:0;margin-top:0">
        <el-form-item label="客户：">
          <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" @change="queryPointList()" :clearable="true">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select size="medium" filterable v-model="searchForm.PROJECT"  placeholder="请选择"
            clearable  >
            <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              <span style="float: left">{{ item.PROJECT_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" id="search" @click="handleSearch" :loading="initLoad">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" plain @click="secondConvert">二次转换</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin-top:20px">
            <el-table :data="newOrderListData" @selection-change="handleSelectionChange" border stripe style="width: 100%">
              <el-table-column type="selection" width="70"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ORDER_ID"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="75"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="50"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="50"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="产品编码" min-width="200"></el-table-column>
              <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="50"></el-table-column>
              <el-table-column prop="TYPE_UNIT" label="单位" min-width="40"></el-table-column>
              <el-table-column prop="PRODUCT_COUNT" label="当前数量" min-width="50"></el-table-column>
              <el-table-column prop="COUNT" label="需转换数量" min-width="50"></el-table-column>
              <el-table-column label="已转换数量" min-width="50">
              <template slot-scope="scope">
                {{ scope.row.PRODUCT_COUNT - scope.row.COUNT }}
              </template>
            </el-table-column>
            </el-table>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  haveDSXMDFun, selectTCFun,
} from 'api/sellOrder';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      initLoad: false,
      points: [],
      allProjectsCopy: [],
      newOrderListData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {},
      companys: [],
      detalCount: [],
    };
  },
  created() {
    // 客户
    this.queryCustomer();
    // 获取项目点列表
    this.loadData();
    // 获取转换后变更产品
    this.queryChangeProductData();
  },
  methods: {
    // -------------------------------------选择客户
    queryCustomer() {
      selectTCFun().then((result) => {
        this.companys = result.length > 0 ? this.$util.listRemoveDuplicates(result[0].company) : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 客户改变 触发 拉取项目点
    queryPointList() {
      this.searchForm.PROJECT = '';
      this.loadData();
    },
    // -----------------------转换后变更产品
    queryChangeProductData() {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 110,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_COMPANY) { // 客户
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT != '') { // 项目点
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL != 0) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      this.initLoad = true;
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.newOrderListData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.newOrderListData = [];
          this.totalCount = 0;
        }
        this.initLoad = false;
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryChangeProductData();
    },
    // ----------------------------------------点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      // 获取团餐客户订单列表
      this.queryChangeProductData();
    },
    // ---------------------------------------获取项目点信息列表
    loadData() {
      const params = {};
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      haveDSXMDFun(params).then((result) => {
        this.points = result.length > 0 ? result[0].project : [];
        this.allProjectsCopy = this.points;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 清除项目点 触发
    handleSelectionChange(val) {
      this.detalCount = val.map((item) => ({ ORDER_ID: item.ORDER_ID, COUNT: item.COUNT, ORDER_DETAIL_ID: item.DETAIL_ID }));
    },
    // 二次转换
    secondConvert() {
      if (this.detalCount.length == 0) {
        this.$message.show({ text: '请选择产品', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 111,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        DETAIL_LIST: this.detalCount,
      };
      http.post(params).then((result) => {
        if (!result.length) {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.queryChangeProductData();
        } else {
          if (JSON.stringify(result[0]) != '{}') {
            this.$message.show({ text: '该产品未配置转换信息', type: 'warning' });
            this.queryChangeProductData();
          }
        }
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
        this.queryChangeProductData();
      });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/changeProductsAfterConversion.vue